import { ChangeEvent, useState, useRef } from "react";
import { Button, Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import UploadGenericFileDialog from "../form/UploadGenericFileDialog";


export default function UploadFile(props = {}) {
  const [filename, setFilename] = useState("");
  const [csvData, setCsvData] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);

  const fileInputRef = useRef(null);

  const reset = () => {
    setFilename("")
    fileInputRef.current.value = ""
    setCsvData("")
  }

  const handleFileUpload = (e) => {
    if (!e.target.files) {
      return;
    }
    const file = e.target.files[0];
    const { name } = file;
    setFilename(name);

    const reader = new FileReader();
    reader.onload = (evt) => {
      if (!evt?.target?.result) {
        return;
      }
      const { result } = evt.target;
      setCsvData(result)
    };
    reader.readAsBinaryString(file);
  };

  const onCancel = () => {
    reset()
    setDialogOpen(false)
  }

  const showDialog = () => {
    setDialogOpen(true)
  }

  const onConfirm = () => {
    fileInputRef.current.click()
  }

  const onUpload = () => {
    props.handleCsvData(csvData, filename, reset);
    setDialogOpen(false)
  }

  return (
    <>
      <Button
        component="label"
        variant="outlined"
        startIcon={<UploadFileIcon />}
        sx={{ marginRight: "1rem" }}
        onClick={props.onClick}
      >
        Upload File
      </Button>
    </>
  );
}
